import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * Injects Schema.org Restaurant + Menu JSON-LD into <head>.
 * Fetches structured payload from /api/menu/schema.json so AI crawlers
 * (Perplexity, ChatGPT, Gemini) see the canonical, server-generated schema.
 */
export default function MenuJsonLd() {
  useEffect(() => {
    let scriptEl;
    const staticScript = document.getElementById("biga-jsonld");
    const staticJson = staticScript?.textContent;
    api.get("/menu/schema.json").then((r) => {
      scriptEl = staticScript || document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.id = "biga-jsonld";
      scriptEl.text = JSON.stringify(r.data);
      if (!staticScript) document.head.appendChild(scriptEl);
    }).catch(() => {});
    return () => {
      if (scriptEl && staticScript && staticJson !== undefined) {
        scriptEl.textContent = staticJson;
      } else if (scriptEl?.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, []);
  return null;
}
